export default __webpack_public_path__ + "static/media/A1.03a41f32.jpeg";